export function formatCLP(value) {
  if (value == null || isNaN(value)) return "$0";
  return "$" + Number(value).toLocaleString("es-CL");
}

export function formatTracking(num) {
  if (!num) return "—";
  const s = String(num);
  return s.replace(/(\d{4})(?=\d)/g, "$1 ").trim();
}

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "hace instantes";
  if (diff < 3600) return `hace ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `hace ${Math.floor(diff / 3600)} h`;
  return `hace ${Math.floor(diff / 86400)} d`;
}

export function dateLabel(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  const parts = new Intl.DateTimeFormat("es-CL", {
    timeZone: "America/Santiago", day: "2-digit", month: "2-digit", year: "numeric",
  }).formatToParts(d);
  const get = (t) => parts.find((p) => p.type === t)?.value;
  return `${get("day")}-${get("month")}-${get("year")}`;
}

export function dateTimeLabel(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  const parts = new Intl.DateTimeFormat("es-CL", {
    timeZone: "America/Santiago", day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: false,
  }).formatToParts(d);
  const get = (t) => parts.find((p) => p.type === t)?.value;
  return `${get("day")}-${get("month")}-${get("year")} ${get("hour")}:${get("minute")}`;
}

export const STATUS_META = {
  PUBLICADO: { label: "Publicado", color: "bg-blue-100 text-blue-700" },
  BUSCANDO_TRANSPORTISTA: { label: "Buscando transportista", color: "bg-amber-100 text-amber-700" },
  ADJUDICADO: { label: "Adjudicado", color: "bg-indigo-100 text-indigo-700" },
  TRANSPORTISTA_EN_CAMINO: { label: "En camino", color: "bg-indigo-100 text-indigo-700" },
  EN_ORIGEN: { label: "En origen", color: "bg-indigo-100 text-indigo-700" },
  CARGA_RECOGIDA: { label: "Carga recogida", color: "bg-indigo-100 text-indigo-700" },
  EN_TRASLADO: { label: "En traslado", color: "bg-indigo-100 text-indigo-700" },
  ENTREGADO: { label: "Entregado", color: "bg-emerald-100 text-emerald-700" },
  COMPLETADO: { label: "Completado", color: "bg-emerald-100 text-emerald-700" },
  CANCELADO: { label: "Cancelado", color: "bg-red-100 text-red-700" },
};

export function statusBadge(status) {
  return STATUS_META[status] || { label: status, color: "bg-zinc-100 text-zinc-700" };
}

export const ACCREDITATION_META = {
  PENDIENTE: { label: "Pendiente", color: "bg-zinc-100 text-zinc-700" },
  EN_REVISION: { label: "En revisión", color: "bg-amber-100 text-amber-700" },
  APROBADO: { label: "Aprobado", color: "bg-emerald-100 text-emerald-700" },
  RECHAZADO: { label: "Rechazado", color: "bg-red-100 text-red-700" },
  SUSPENDIDO: { label: "Suspendido", color: "bg-red-100 text-red-700" },
};
